// Hash table to quickly lookup name of card based on its rank
export const cardNames = {
    "1": "ace",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "10": "10",
    "11": "jack",
    "12": "queen",
    "13": "king"
};